import { toast } from "react-toastify";
import Swal from "sweetalert2";
import { Delete } from "../api/BaseApi";

export const successMessage = () => {
  toast.success("عملیات با موفقیت انجام شد", {
    position: "top-left",
    autoClose: 2000,
    hideProgressBar: false,
    closeOnClick: true,
    pauseOnHover: true,
    draggable: true,
    progress: undefined,
    theme: "light",
    //icon: "🦄",
  });
};
export const successMessagePro = (msg) => {
  toast.success(msg, {
    position: "top-left",
    autoClose: 8000,
    hideProgressBar: false,
    closeOnClick: true,
    pauseOnHover: true,
    draggable: true,
    progress: undefined,
    theme: "light",
    //icon: "🦄",
  });
};
export const successMessageTamin = (msg) => {
  toast.success(msg, {
    position: "top-left",
    autoClose: 8000,
    hideProgressBar: false,
    closeOnClick: true,
    pauseOnHover: true,
    draggable: true,
    progress: undefined,
    theme: "light",
    //icon: "🦄",
  });
};
export const AddListMessage = (msg) => {
  toast.success(msg, {
    position: "top-left",
    autoClose: 4000,
    hideProgressBar: false,
    closeOnClick: true,
    pauseOnHover: true,
    draggable: true,
    progress: undefined,
    theme: "light",
    //icon: "🦄",
  });
};
export const errorMessage = (msg) => {
  toast.error(msg, {
    position: "top-left",
    autoClose: 4000,
    hideProgressBar: false,
    closeOnClick: true,
    pauseOnHover: true,
    draggable: true,
    progress: undefined,
    theme: "light",
    //icon: "🦄",
  });
};

export const deleteAlret = ({ row, fetchData }) => {
  Swal.fire({
    title: "آیا میخواهید حذف شود ؟",
    cancelButtonText: "خیر",
    cancelButtonColor: "#d33",
    confirmButtonText: "بله",
    confirmButtonColor: "#3085d6",
    icon: "warning",
    showCancelButton: true,
  }).then(async (result, err) => {
    console.log(err);
    console.log(result);
    if (result.isConfirmed) {
      await Delete(row.original.links[1].href)
        .then((res) => {
          successMessage();
          fetchData();
        })
        .catch((error) => {
          // پردازش خطا
          if (error.response) {
            var err = error.response.data;
            // اگر پاسخی از سمت سرور آمد، می‌توانید بازخورد سرور را بررسی کنید
            errorMessage(err.message);
            //setIsLoadingHeightAndWeight(false);
          } else if (error.request) {
            // اگر درخواستی برای سرور ارسال شده بود ولی پاسخی دریافت نشد
            errorMessage(error.request.message);
          } else {
            // مشکلی در هنگام پردازش درخواست پیش آمد
            errorMessage("مشکلی در هنگام پردازش درخواست پیش آمد");
            //setIsLoadingHeightAndWeight(false);
          }
        });
    } else if (result.isDenied) {
      errorMessage(err.message);
    }
  });
};
